import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../../App.css";
import StartExamContent from "../../components/PlayContent/Exam/StartExamContent";
import {
  getExamQuestions,
  getQuestionsCount,
} from "../../endpoints/Assessment/functions";
const StartExamPage = (props) => {
  const { examName } = useParams();
  const [allQuestions, setAllQuestions] = useState([]);
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [count, setCount] = useState(0);
  useEffect(() => {
    const fetchData = async () => {
      try {
        await questionCount(examName);
        await getAllQuestionsByExam(examName);
      } catch (error) {
        console.log("Error at StartExamPage mount", error);
      }
    };
    fetchData();
  }, [examName]);

  async function getAllQuestionsByExam(examSelected) {
    try {
      let response = await getExamQuestions(examSelected, props.token);
      const parsedResponse = response.data.map((question) => {
        question.choices = shuffle(question.choices);
        return question;
      });
      setAllQuestions(parsedResponse);
    } catch (error) {
      console.log("Error at getAllQuestionsByExam", error);
    }
    setCurrentQuestion(0);
  }
  async function questionCount(selectedExam) {
    try {
      let response = await getQuestionsCount(selectedExam, props.token);
      setCount(response.data);
    } catch (error) {
      console.log("Error at questionCount", error);
    }
  }

  function shuffle(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = Math.floor(Math.random() * (i + 1));
      [array[i], array[j]] = [array[j], array[i]]; // Swap elements
    }
    return array;
  }

  if (count) {
    return (
      <StartExamContent
        allQuestions={allQuestions}
        currentQuestion={currentQuestion}
        setCurrentQuestion={setCurrentQuestion}
        count={count}
        token={props.token}
      />
    );
  }
};

export default StartExamPage;
